import React from 'react';
import { Eye, Palette, MapPin, Users, Camera, Award } from 'lucide-react';
import { content } from '../data/content';

const iconMap = {
  Eye,
  Palette,
  MapPin,
  Users,
  Camera,
  Award
};

const WhyChoose = () => {
  return (
    <section id="why-choose" className="py-32 bg-neutral-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <div className="text-center mb-24">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-amber-50 mb-8">
            Perché sceglierlo per il tuo brand
          </h2>
          <p className="text-xl text-amber-100/60 max-w-3xl mx-auto font-light leading-relaxed">
            Un asset distintivo che eleva la tua strategia di experiential marketing
          </p>
          <div className="w-24 h-1 bg-amber-500/40 mx-auto mt-8"></div>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {content.whyChoose.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div
                key={index}
                className="group relative bg-gradient-to-br from-amber-50/5 to-transparent border border-amber-200/10 rounded-2xl p-8 hover:border-red-500/30 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-red-600/10"
              >
                {/* Icon */}
                <div className="mb-6">
                  <div className="relative inline-block">
                    <div className="absolute inset-0 bg-red-600/20 blur-xl rounded-full group-hover:bg-red-600/30 transition-all"></div>
                    <div className="relative bg-gradient-to-br from-red-600 to-red-700 rounded-xl p-4 group-hover:scale-110 transition-transform duration-300">
                      <IconComponent className="w-8 h-8 text-amber-50" />
                    </div>
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-amber-50 mb-3 group-hover:text-amber-100 transition-colors">
                  {item.title}
                </h3>
                <p className="text-amber-100/70 leading-relaxed">
                  {item.description}
                </p>

                {/* Hover Accent */}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-red-600 to-amber-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-b-2xl"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
